import { connect } from "react-redux";

import LocationDetailView from "./LocationDetailView";
import ShipmentsStatusState from "../shipment-status/ShipmentsState";
import SearchState from "../shipment-search/ShipmentSearchState";
import LocationDetailState from "./LocationDetailState";

import {
  getSelectedLocationId,
  selectSelectedLocation
} from "../locations/LocationsState";
import DomainDataState from "../domain-data/DomainDataState";
import LadsState from "../lads/LadsState";

function mapStateToProps(state) {
  const { getLadsList } = LadsState.selectors;

  return {
    ...state.maps,
    location: selectSelectedLocation(state),
    ladsList: getLadsList(state),
    locations: state.locations.data,
    locationID: getSelectedLocationId(state),
    shipments: state.shipmentsStatus.watchlistShipments,
    exceptionTypes: DomainDataState.selectors.getExceptionTypes(state),
    locationShipments: LocationDetailState.selectors.getLocationShipments(
      state
    ),
    shipmentSummaries: LocationDetailState.selectors.getShipmentSummaries(state)
  };
}

function mapDispatchToProps(dispatch) {
  const { fetchShipmentTotalsByLocation } = ShipmentsStatusState.actionCreators;

  return {
    fetchShipmentTotalsByLocation: location =>
      dispatch(fetchShipmentTotalsByLocation(location)),
    fetchLocationShipments: locationId =>
      dispatch(
        LocationDetailState.actionCreators.fetchLocationShipments(locationId)
      ),
    fetchShipment: shipmentId =>
      dispatch(LocationDetailState.actionCreators.fetchShipment(shipmentId)),
    clearLocationShipments: () =>
      dispatch(LocationDetailState.actionCreators.clearLocationShipments()),
    pushSearchView: () => dispatch({ type: "SHIPMENT_SEARCH" }),
    setSearchFilter: (key, value) =>
      dispatch(SearchState.actionCreators.setSearchFilter(key, value)),
    setSearchCategory: category =>
      dispatch(SearchState.actionCreators.setSearchCategory(category)),
    setSearch: (label, value) => dispatch(SearchState.actionCreators.setSearch(label, value)),
    clearSearchFilters: () =>
      dispatch(SearchState.actionCreators.clearSearchFilters()),
    searchShipments: (searchObj, searchCategory, searchFilters) =>
      dispatch(
        SearchState.actionCreators.searchShipments(
          searchObj,
          searchCategory,
          searchFilters
        )
      ),
    pushLocationsDetailView: locationID =>
      dispatch({
        type: "LOCATION_DETAIL",
        payload: { location_id: locationID }
      })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationDetailView);



// WEBPACK FOOTER //
// ./src/modules/location-detail/LocationDetailViewContainer.js